<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input v-model="listQuery.nickname" placeholder="用户昵称" clearable style="width: 200px;" class="filter-item" @keyup.enter.native="handleFilter" />
      <el-input v-model="listQuery.phone" placeholder="手机号" clearable style="width: 150px;" class="filter-item" @keyup.enter.native="handleFilter" />
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">搜索</el-button>
    </div>

    <el-table v-loading="listLoading" :data="list" border fit highlight-current-row style="width: 100%;">
      <el-table-column label="用户ID" prop="userId" align="center" width="80" />
      <el-table-column label="OpenID" prop="openId" align="center" width="200">
        <template slot-scope="{row}">
          <span v-if="row.openId" :title="row.openId">{{ row.openId }}</span>
          <span v-else style="color: #999;">-</span>
        </template>
      </el-table-column>
      <el-table-column label="UnionID" prop="unionId" align="center" width="200">
        <template slot-scope="{row}">
          <span v-if="row.unionId" :title="row.unionId">{{ row.unionId }}</span>
          <span v-else style="color: #999;">-</span>
        </template>
      </el-table-column>
      <el-table-column label="昵称" prop="nickname" align="center" width="120" />
      <el-table-column label="手机号" prop="phone" align="center" width="120" />
      <el-table-column label="头像" prop="avatarUrl" align="center" width="80">
        <template slot-scope="{row}">
          <el-avatar :src="row.avatarUrl" size="small" />
        </template>
      </el-table-column>
      <el-table-column label="性别" prop="gender" align="center" width="80">
        <template slot-scope="{row}">
          <span v-if="row.gender === 'male'">男</span>
          <span v-else-if="row.gender === 'female'">女</span>
          <span v-else>未知</span>
        </template>
      </el-table-column>
      <el-table-column label="注册时间" prop="createdAt" align="center" width="160">
        <template slot-scope="{row}">
          <span>{{ row.createdAt | parseTime }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="{row}">
          <el-button type="info" size="mini" @click="handleViewDetail(row)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination v-show="total>0" :total="total" :page.sync="listQuery.pageNum" :limit.sync="listQuery.pageSize" @pagination="getList" />

    <el-dialog title="用户详情" :visible.sync="detailDialogVisible" width="600px">
      <el-descriptions :column="2" border>
        <el-descriptions-item label="用户ID">{{ detailData.userId }}</el-descriptions-item>
        <el-descriptions-item label="OpenID" :span="2">{{ detailData.openId || '-' }}</el-descriptions-item>
        <el-descriptions-item label="UnionID" :span="2">{{ detailData.unionId || '-' }}</el-descriptions-item>
        <el-descriptions-item label="昵称">{{ detailData.nickname || '-' }}</el-descriptions-item>
        <el-descriptions-item label="手机号">{{ detailData.phone || '-' }}</el-descriptions-item>
        <el-descriptions-item label="邮箱">{{ detailData.email || '-' }}</el-descriptions-item>
        <el-descriptions-item label="性别">
          <span v-if="detailData.gender === 1">男</span>
          <span v-else-if="detailData.gender === 2">女</span>
          <span v-else>未知</span>
        </el-descriptions-item>
        <el-descriptions-item label="头像" :span="2">
          <el-avatar v-if="detailData.avatarUrl" :src="detailData.avatarUrl" size="medium" />
          <span v-else>无</span>
        </el-descriptions-item>
        <el-descriptions-item label="注册时间">{{ detailData.createdAt | parseTime }}</el-descriptions-item>
        <el-descriptions-item label="更新时间">{{ detailData.updatedAt | parseTime }}</el-descriptions-item>
      </el-descriptions>
      <div slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listUsers, getUser } from '@/api/user'
import Pagination from '@/components/Pagination'

export default {
  name: 'GlobalUserList',
  components: { Pagination },
  filters: {
    parseTime(time) {
      if (!time) return ''
      const date = new Date(time)
      return date.toLocaleString()
    }
  },
  data() {
    return {
      list: null,
      total: 0,
      listLoading: true,
      listQuery: {
        pageNum: 1,
        pageSize: 20,
        nickname: undefined,
        phone: undefined
      },
      detailDialogVisible: false,
      detailData: {}
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.listLoading = true
      listUsers(this.listQuery).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.pageNum = 1
      this.getList()
    },
    handleViewDetail(row) {
      getUser(row.userId).then(response => {
        this.detailData = response.data
        this.detailDialogVisible = true
      })
    }
  }
}
</script>

<style scoped>
.filter-container {
  margin-bottom: 20px;
}
.filter-item {
  margin-right: 10px;
}
</style>
